import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { DivisionesComponent } from './divisiones/divisiones.component';
import { PartnershipComponent } from './partnership/partnership.component';
import { ColaboradoresComponent } from './colaboradores/colaboradores.component';
import { BlogComponent } from './blog/blog.component';
import { ContactoComponent } from './contacto/contacto.component';

const routes: Routes = [
  {
    path: 'inicio',
    component: HomeComponent
  },
  {
    path: 'nosotros',
    component: NosotrosComponent
  },
  {
    path: 'divisiones',
    component: DivisionesComponent
  },
  {
    path: 'partnership',
    component: PartnershipComponent
  },
  {
    path: 'vinculacion',
    component: ColaboradoresComponent
  },
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: 'contacto',
    component: ContactoComponent
  },
  {
    path: '**',
    redirectTo: 'inicio'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }